// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1861":"2b71b6db","4242":"2b71b6db","7244":"37bc6b2f"}[chunkId] + ".chunk.css";
};